<h1 class="medium">Hvad skal kunden faktureres?</h1>
<div class="flow__nav">
  <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
    <mat-icon svgIcon="remove"></mat-icon>
  </button>
</div>
@if (serviceaftale) {
  <app-slutopgoerelse
    [form]="slutopgoerelseForm"
    [kundeSegment]="$safeNavigationMigration(serviceaftale.kunde?.kundetype?.kundeSegment)"
    [currentServiceinterval]="$safeNavigationMigration(serviceaftale?.currentServiceinterval)"
    [isWithFrieTilkald]="$safeNavigationMigration(serviceaftale?.hasFrieTilkald)"
    [eftersynsInterval]="$safeNavigationMigration(serviceaftale?.serviceAbonnement?.eftersynInterval)"
    [serviceaftaleId]="$safeNavigationMigration(serviceaftale?.id)"
    [endDate]="endDate"
  ></app-slutopgoerelse>
}
@if (endDateTodayOrBefore) {
  <app-slutopgoerelse-draft
    [form]="slutopgoerelseForm"
    [serviceaftaleId]="$safeNavigationMigration(serviceaftale?.id)"
    [kundesegment]="$safeNavigationMigration(serviceaftale?.kunde?.kundetype?.kundeSegment)"
    [endDate]="endDate"
  ></app-slutopgoerelse-draft>
}
@if (serviceaftale?.fakturaStop) {
  <div class="orange icon-with-text">
    <mat-icon svgIcon="obs-solid"></mat-icon>
    <span>Bemærk: Der er fakturastop på aftalen</span>
  </div>
}
@if (slutopgoerelseForm.controls.createSlutopgoerelse.value) {
  <div>
    <small>{{ momsTekst() }}</small>
  </div>
}
<div style="padding-top: 20px">
  @if (isEdit) {
    <button mat-raised-button [disabled]="$safeNavigationMigration(slutopgoerelseForm?.invalid)" (click)="UpdateSlutopgoerelse()">
      Gem slutopgørelse
    </button>
  }
  <button mat-raised-button [disabled]="!isSlutopgPastDueDate || serviceaftale?.fakturaStop" (click)="AfregnSlutopgoerelse()">
    Send slutopgørelse
  </button>
</div>
<div class="flow__resume">
  <app-slutopgoerelse-quickview [serviceaftale]="serviceaftale" [endDate]="endDate"></app-slutopgoerelse-quickview>
</div>
